import {
  CreateCcDataResult,
  IAssemblyComponent,
  IAssemblyScreen,
  ISection,
  RotationControlSignals,
} from 'gcf-player/shared-utils';
import { IOrientation } from 'src/constants/constants';

export enum EComponentInstanceDataTarget {
  SCHEDULE_ITEM = 'schedule_item',
  SCHEDULE_ITEM_OVERRIDE = 'schedule_item_override',
  ASSEMBLY = 'assembly',
  PRODUCT = 'product',
  PRODUCT_OVERRIDE = 'product_override',
}
export interface ComponentInstanceData {
  target: EComponentInstanceDataTarget;
  ref: IAssemblyComponent;
  section: ISection;
  backups?: IAssemblyComponent[];
  parent?: unknown;
  screenSequence: number;
}

export interface SelectedSection {
  position?: number;
  screenSequence: number;
  top: number;
  left: number;
  id: number | string;
}

export interface IScreenSize {
  width: number;
  height: number;
}

export interface IMinScreenSize {
  [IOrientation.VERTICAL]: IScreenSize;
  [IOrientation.HORIZONTAL]: IScreenSize;
}

export interface IPreviewSectionsProps {
  screen: IAssemblyScreen;
  screenKey: string;
  screenWidth: number | undefined;
  screenHeight: number | undefined;
  previewData?: CreateCcDataResult;
  activePosition: number | string;
  selectedSection?: SelectedSection;
  highlightAll: boolean;
  clickable: boolean;
  showSectionPill: boolean;
  previewZoom: number;
}

export interface IPreviewSectionContentProps {
  section: ISection;
  screenKey: string;
  screenWidth: number | undefined;
  screenHeight: number | undefined;
  activePosition: number | string;
  clickable: boolean;
}

export interface IGcfPreview {
  previewData?: CreateCcDataResult;
  activePosition?: number | string;
  activeScreen?: number | string;
  highlightAll?: boolean;
  showSectionPill?: boolean;
  selectedSection?: SelectedSection;
  minScreenSize?: IMinScreenSize;
  onScreenLabelClick?: (screenSequence: string) => void;
  onClick?: (
    data: ComponentInstanceData,
    selectedSection: SelectedSection | undefined,
  ) => void;
  onUnselectSection?: () => void;
  signals?: RotationControlSignals;
}
